<template>
  <div id="loginContainer" class="login-form">
    <loading :active="isLoading" :can-cancel="false" :is-full-page="true" />
    <img :src="logo" alt="logo" />

    <h2 class="login-heading">
      <v-icon size="small" color="teal-darken-2" >mdi-lock</v-icon>
      Log into the app!
      <br/>
      <small class="color_black">{{ dataset }}</small>
    </h2>
    <v-form ref="form" v-model="valid" lazy-validation>
      <!-- <v-text-field v-model="username" label="AGRIS Username" required></v-text-field>
      <v-text-field
        v-model="password"
        :type="show1 ? 'text' : 'password'"
        name="input-10-1"
        label="AGRIS Password"
        @click:append="show1 = !show1"
      ></v-text-field>

      <v-snackbar
        v-model="snackbar"
        :bottom="false"
        :left="false"
        :multi-line="false"
        :right="false"
        :timeout="6000"
        :top="true"
        :vertical="false"
      >
        {{ snackbarText }}
        <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>

      <v-row wrap align-center>
        <v-col xs12 sm6>
          <v-btn
            block
            class="green darken-1"
            dark
            :disabled="!valid"
            @click="appsettings"
          >Change Dataset</v-btn>
        </v-col>
        <v-col xs12 sm1>&nbsp;</v-col>
        <br />
        <v-col xs12 sm5>
          <v-btn block :disabled="!valid || (username=='' || password=='')
           " @click="login">LOGIN</v-btn>
        </v-col>

        <v-progress-linear :indeterminate="true" height="5"
        color="green" v-if="isConnected"></v-progress-linear>
        <v-col xs12 sm6>
          <br />
          <span class="grey--text">{{errorMessage}}</span>
        </v-col>
      </v-row> -->

      <!-- <v-container wrap align-center> -->
        <!-- <v-row  > -->
        <v-row no-gutters>
          <v-col xs="10" sm="12" md="12">
            <v-text-field id="ta-login-username" v-model="username" label="AGRIS Username" required   variant="underlined"/>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col xs="10" sm="12" md="12">
            <v-text-field id="ta-login-password" 
              v-model="password"
              :type="show1 ? 'text' : 'password'"
              name="input-10-1"
              label="AGRIS Password"
              @click:append="show1 = !show1"
              variant="underlined"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-snackbar
            v-model="snackbar"                   
            :multi-line="false"      
            :timeout="6000"
            :location="'top'"
            :vertical="false"
          >
            {{ snackbarText }}
            <template v-slot:actions>
              <v-btn color="pink" id="ta-login-close"  variant="text" @click="snackbar = false">Close</v-btn>         
            </template>
          </v-snackbar>
        </v-row>
        <v-row no-gutters>
          <v-col xs="3" sm="5" md="6">           
            <v-btn
              id="ta-login-changedataset" 
              variant="outlined"
              class="bg-green-darken-1"
              :disabled="!valid"
              @click="appsettings"
              size="large"
              style="color: white;"
            >Change Dataset</v-btn>
          </v-col>
          <v-col xs="2" sm="1" md1>&nbsp;</v-col>
          <br />
          <v-col xs="3" sm="5" md="5">
            <v-btn
              id="ta-login-login" 
              block
              size="large"
              :disabled="!valid || (username == '' || password == '')
              "
              @click="login">LOGIN</v-btn>
          </v-col>
        </v-row>
        <v-progress-linear
          :indeterminate="true"
          height="5"
          color="green"
          v-if="isConnected" />
        <v-row>
          <v-col col="12" sm="6">
            <br />
            <span class="text-grey">{{errorMessage}}</span>
          </v-col>
        </v-row>
       
        
        <!-- </v-row > -->
      <!-- </v-container> -->

    </v-form>
  </div>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import foot2 from '@/assets/SalesReview.svg';
import DataService from '@/services/data-service';
import { agentBus } from '@/main';
import CryptoService from '@/services//crypto-services';
import * as Sentry from "@sentry/vue";
import { mdiLock } from '@mdi/js'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

const dataService = new DataService();
const cryptoService = new CryptoService();

export default {
  name: 'login',
  loading: true,
  data: () => ({
    logo: foot2,
    username: '',
    password: '',
    isAuthenticated: false,
    valid: true,
    isLoading: false,
    show1: false,
    snackbar: false,
    snackbarText: '',
    dataset: '',
    rules: {
      required: value => !!value || 'Required.',
      emailMatch: v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'E-mail must be valid',
    },
    isConnected: false,
    errorMessage: '',
  }),
  components: {
    Loading,
  },
  created() {
    if (!localStorage.agentInfo) {
      this.$router.replace('/appSettings');
    }
    if (localStorage.usertData) {
      this.$router.replace('/salesReview');
    }
    const sentrytag  = localStorage.getItem('sentrytag');
    if (sentrytag != undefined && sentrytag != null){
      this.dataset = sentrytag.split('-')[1];
    }
  },
  methods: {
    login() {
      this.isLoading = true;
      this.isDatasetConnectFailed = false;
      this.errorMessage = '';
      if (this.username !== '' && this.password !== '') {
        this.isConnected = true;
        const agentInfo = JSON.parse(localStorage.agentInfo);
        dataService
          .login(
            this.username,
            this.password,
            agentInfo.SessionID,
            agentInfo.TenantId,
          )
          .then((response) => {
            if (!response.IsAuthenticated) {
              this.isConnected = false;
              this.snackbar = true;
              this.snackbarText =
                'Incorrect user or password please try again.';
              this.isLoading = false;
            } else {
              this.isConnected = false;
              const usertData = {
                userEmail: this.username,
                Password: cryptoService.encryptString(this.password),
                AgrisSessionId: response.Message,
              };
               dataService
                .getAgeisUserPermissions(this.username)
                .then((permission) => {
                  console.log(permission);
                  usertData.Permission = permission;
                  localStorage.usertData = JSON.stringify(usertData);
                  this.$router.replace('/salesReview/');
                }).catch((error)=>{
                    console.log(error);
                    Sentry.captureMessage(
                      "Handled Error: " + JSON.stringify(error)
                    );
                    this.$router.replace('/salesReview/');
                });
              Sentry.configureScope((scope) => {
                scope.setTag('Username', usertData.userEmail);
              });
              this.$store.commit('setUserInfo', usertData);
              this.isLoading = false;
              dataService
                .getAgentType()
                .then((agentType) => {
                  console.log(agentType);
                  localStorage.setItem("AgentType", agentType.AgentType);
                })
                .catch((error) => {
                  console.log(error);
                  Sentry.captureMessage(
                    "Handled Error: " + JSON.stringify(error)
                  );
                });
              // dataService
              //   .SetUserPrefrences()
              //   .then(() => {
              //     this.isLoading = false;
              //     console.log("SetUserPrefrences");
              //     this.$router.replace("/salesReview/");
              //   })
              //   .catch(e => {
              //     this.isLoading = false;
              //     console.log(e, "Error SetUserPrefrences");
              //     this.$router.replace("/salesReview/");
              //   });
            }
          })
          .catch((err) => {
            console.log(err);
            this.error = err;
            this.isConnected = false;
            this.snackbar = true;
            this.isLoading = false;
            this.snackbarText = 'Dataset is not responding.';
          });
      }
    },
    appsettings() {
      this.$router.replace('/appSettings');
    },

    // this.$router.replace("/salesreviewe");
  },
};
</script>
<style>
body {
  background: #fff;
  font-family: Arial, Helvetica, sans-serif;
}
html,
body {
}
.color_black {
  color: Black;
}
.login-form {
  /* background: #fff;
  width: 30%;
  margin: auto auto auto auto; */
  border: 1px solid #ccc;
  padding: 2%;
  width: 30%;
  height: auto;
  background: #fff;

  position: absolute; /*it can be fixed too*/
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin-top: 80px;
  margin-bottom: 80px;
  margin-left: auto;
  margin-right: auto;

  /*this to solve "the content will not be cut when the window is smaller than the content": */
  max-width: 100%;
  max-height: 100%;
}

#loginContainer img {
  width: 40%;
  height: 50%;
  display: block;
  margin: auto;
}

.login-heading {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 25px;
  text-align: center;
  color: darkgreen;
  margin-top: -20px;
}
.form-container {
}

#app {
  background: #fff;
}

.page {
  position: fixed;
  width: inherit;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
